import { useRef, useState, createElement, useEffect, useContext } from 'react';
import CheckboxGroupContext from './context';
import classNames from 'classnames';
import './index.scss';
const ColorfulCheckbox = props => {
    const { type = 'checkbox', id, name, tabIndex, disabled, value = '', label, border = 'none', onClick, onChange, ...otherProps } = props;
    const input = useRef(null);
    const groupContext = useContext(CheckboxGroupContext);
    const [checked, setChecked] = useState(() => {
        if ('checked' in props) {
            return props.checked;
        }
        else if (groupContext?.value) {
            return type === 'checkbox' ? groupContext.value.includes(props.value) : groupContext.value === props.value;
        }
        else {
            return props.defaultChecked;
        }
    });
    const prefixCls = `au-${type}`;
    const classString = classNames(prefixCls, {
        [`${prefixCls}-checked`]: checked,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-border`]: border === 'solid',
    });
    useEffect(() => {
        setChecked(() => {
            if ('checked' in props) {
                return props.checked;
            }
            else if (groupContext?.value) {
                return type === 'checkbox' ? groupContext.value.includes(props.value) : groupContext.value === props.value;
            }
            else {
                return props.defaultChecked;
            }
        });
    }, [groupContext?.value, props.defaultChecked]);
    const focus = () => {
        input.current.focus();
    };
    const blur = () => {
        input.current.blur();
    };
    const handleChange = e => {
        if (disabled) {
            return;
        }
        if (!('checked' in props)) {
            setChecked(e.target.checked);
        }
        if (onChange) {
            onChange(e);
        }
    };
    return (createElement("span", { className: classString, onFocus: focus, onBlur: blur, ...otherProps },
        createElement("input", { id: id, ref: input, type: type, name: name, value: value, disabled: disabled, checked: !!checked, tabIndex: tabIndex, className: `${prefixCls}-input`, onChange: handleChange }),
        createElement("span", { className: `${prefixCls}-inner` }),
        createElement("span", { className: `${prefixCls}-inner-text` }, label || '选择框')));
};
ColorfulCheckbox.displayName = 'ColorfulCheckbox';
export default ColorfulCheckbox;
